import { useCallback, useEffect, useState } from 'react';

import { getJobTitles } from '../../api/services/Organizers';

export type JobTitleOption = { value: string; label: string; group: string };

interface UseJobTitlesHook {
  jobTitleOptions: JobTitleOption[];
  isFetching: boolean;
}

export const useJobTitles = (enabled = true): UseJobTitlesHook => {
  const [jobTitleOptions, setJobTitleOptions] = useState<JobTitleOption[]>([]);
  const [isFetching, setIsFetching] = useState(false);

  const abortController = new AbortController();

  useEffect(() => {
    if (enabled) {
      fetchJobTitles();
    }
  }, [enabled]);

  useEffect(() => {
    return () => {
      abortController.abort();
    };
  }, []);

  const fetchJobTitles = useCallback(async () => {
    setIsFetching(true);
    const response = await getJobTitles(abortController.signal);

    if (abortController.signal.aborted) {
      return;
    }
    if (response?.type === 'success') {
      setJobTitleOptions(response.data.jobTitles);
    }
    setIsFetching(false);
  }, []);

  return { jobTitleOptions, isFetching };
};
